import React, { Component } from 'react';
import { CATEGORIES, LOCATION, DOMAIN } from '../../utils/Constants';
import SmallLoader from '../pieces/SmallLoader';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import axios from 'axios';

const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return (<RequiredError/>);
  }
};
 
const email = (value) => {
  if (!value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
    return (<EmailError value={value}/>);
  } 
};

function RequiredError(){
  return (
    <label className="error">This field is required.</label>
  )
}
function EmailError({...props}){
  return (
    <label className="error">{props.value} is not a valid email.</label>
  )
}

class SignupBusiness extends Component {
  state = {
    formSubmitted: false,
    formSent: false,
    errors: false
  
  }
  handleSubmit = (e) => {
    e.preventDefault();
    console.log(this.form);
    this.form.validateAll();

    setTimeout(() => {
      window.scrollTo(500, 0);
      if(document.getElementsByClassName('is-invalid-input').length === 0){
        //this.setState({ errors: false })
        this.sendFormData();
      }
      else {
        this.setState({ errors: true })
      }
     
    }, 500);
  }

  sendFormData = () => {
    var form = document.getElementById('cio-signup-form');
    var formArray = [];
    var formString = '';
    for(var i = 0; i < form.elements.length; i++ ){
      var obj = {};
      obj.name = form.elements[i].name;
      obj.value = form.elements[i].value;
      
      formArray.push(obj);
      formString += `${form.elements[i].name}=${form.elements[i].value}&`;
    }

    this.setState({
      formSubmitted: true
    });

    axios.post(`http://www.${DOMAIN}/sendmessage1.php?${formString}`)
      .then(function (response) {
        
        updateState();
      })
      .catch(function (error) {
        console.log(error);
      });

    var updateState = () => {
      this.setState({
        formSubmitted: false,
        formSent: true,
        errors: false
      });
    }
  }
  
  render(){

    return(

        <div className="page-content">
          {this.state.errors &&
            <p className="bold highlight"><label className="error">There were errors in this form. Please review and correct the indicated fields.</label></p>
          }
          
              {this.state.formSubmitted && 
              <SmallLoader/>
              }
              {!this.state.formSent &&
                <Form ref={c => { this.form = c }} noValidate="novalidate" id="cio-signup-form" onSubmit={this.handleSubmit}> 
                  <div className="input-row">
                    <Input type="text" name="business_name" placeholder="Business or event name *" validations={[required]}/>
                  </div>
                  <div className="input-row">
                    <div className="form-item half inline">
                      <Input type="text" name="first_name" placeholder="First name *" validations={[required]}/>
                    </div>
                    <div className="form-item half inline">
                      <Input type="text" name="last_name" placeholder="Last name *" validations={[required]}/>
                    </div>
                  </div>
                  <div className="input-row">
                    <div className="form-item half inline">
                      <Input type="text" className="half inline" name="position" placeholder="Position in company"/>
                    </div>
                    <div className="form-item half inline">
                      <Input type="email" className="half inline" name="email" placeholder="Email * (we will not publish it)" validations={[required, email]}/>
                    </div>
                    
                  </div>
                  <div className="input-row">
                    <Input type="text" name="address" placeholder="Business or event address *" validations={[required]}/>
                  </div>
                  <div className="input-row">
                    <div className="form-item third inline">
                      <Input type="text" name="city" value={LOCATION} validations={[required]}/>
                    </div>
                    <div className="form-item third inline">
                      <Input type="text" name="county" value="Essex" validations={[required]}/>
                    </div>
                    <div className="form-item third inline">
                      <Input type="text" name="postcode" placeholder="Post code *" validations={[required]}/>
                    </div>
                  </div>
                  <div className="input-row">
                    <Input type="text" name="telephone" placeholder="Business telephone"/>
                  </div>
                  <div className="input-row">
                    <Input type="text" name="website" placeholder="Website address"/>
                  </div>
                  <div className="input-row">
                    <Input type="text" name="facebook" placeholder="Facebook page address"/>
                  </div>
                  <div className="input-row">
                    <Input type="text" name="twitter" placeholder="Twitter page address"/>
                  </div>
                  <div className="input-row">
                    <label>Type of business or event:  *</label>
                    <Input list="category" name="category" placeholder="Start typing a category..." validations={[required]}/>

                    <datalist id="category">
                      {CATEGORIES.map((item, idx) => (
                        <option key={idx} value={item.name}/>
                      ))}
                    </datalist>
                  </div>
                  <div className="input-row">
                    <textarea name="description" placeholder="Description of your business, service or event. Here you can list your daily opening hours, date, time and location of event, and any other information you want people to know." validations={[required]}></textarea>
                  </div>
                  <div className="input-row">
                    <div className="checkbox-group">
                        <input type="checkbox" id="checkbox-opt" name="subscribe" defaultChecked/>
                        <label className="checkbox" htmlFor="checkbox-opt"></label>
                    </div>
                    <label className="checkbox-label">Yes, please subscribe me to your mailing list so I can be notified when important updates are made.</label>
                  </div>
                  <div className="input-row">
                    <button  type="submit">Get found!</button>
                  </div>
                  
                </Form>
              }
              
            { this.state.formSent ?
            <div className="form-success">
              <h3 className="color">Thank you!</h3>
              <p>Your submission has been received. You will be notified when your listing is published. If you also signed up to be on our mailing list, you will also be notified whenever there is an important update.</p>
            </div>
            :
            ''
            }

            
          </div>


    );
  }
}
export default SignupBusiness;


// WEBPACK FOOTER //
// ./src/components/blocks/SignupBusiness.js